@import "./base/typography";
@import "./abstracts/functions";
@import "./abstracts/variables";
@import "./base/nav";
@import "./base/responsive";
@import "./base/Installation";
@import "./base/Features";
@import "./base/projects";
@import "./base/support";

.Home-container{
  padding-top:8rem;

  .Home-flex{
    @include center-div;
    flex-direction:column;
    padding-bottom: .5rem;
    border-bottom: 10px solid #222;

    .First-flex{
      text-align: center;
      .Title{
        font-weight: bolder;
        font-size:4rem;

        .special{
          color:$primary-color;
          z-index: -1;
        }
      }
      .text{
        font-size: 25px;
      }
      .button-container{
        padding:1rem 0;
        width:100%;
        .button{
          width:25%;
          height:3.5rem;
          background: $primary-color;
          border-radius: 10px;
          font-size:20px;
          color:$secondary-color;

          &:hover{
            @include transition-ease;
            border-radius: 14px;
            background: linear-gradient(315deg, #4f4285, #433870);
            // box-shadow:  -16px -16px 32px #372e5c,
            //              16px 16px 32px #5d4e9c;
          }
        }
        a{
          .buttonf{
            width:25%;
            height:3.5rem;
            background: $bg-color;
            border:2px solid rgba(34, 34, 34, 0.233);
            border-radius: 10px;
            margin-left:8px;
            font-size:20px;
            color:$text-color;
            &:hover{
              border-radius: 23px;
              background: linear-gradient(315deg, #f0f0f0, #cacaca);
              box-shadow:  -5px -5px 8px #d9d9d9,
                          5px 5px 8px #e7e7e7;
              @include transition-ease;
            }
          }
        }
      }
    }

    .second-flex{

      .Header-logo{
        width:30rem;
      }
    }
  }


  footer{
    @include column;
    @include center-div;
    p{
      font-size:1.5rem;
    }
    .social-icons {
      display:flex;

      a{
        .icon{
          color:$text-color;
          font-size: 2rem;
          padding: 1rem;
        }
      }
      
    }

    .country{
      padding: .5rem 0;
    }

  }
}